import {
    propertySyncChannel,
    PropertyBroadcastMessageTypes,
} from './broadcastChannels';
import { store } from '../store/store';
import { aroApiSlice } from '../store/slices/apiSlice/apiSlice';

export const initPropertySyncListener = (/* store */) => {
    propertySyncChannel.onmessage = (e) => {
        console.log('onmessage', e.data);
        if (e.data?.type === PropertyBroadcastMessageTypes.PropertyUpdated) {
            store.dispatch(
                aroApiSlice.util.invalidateTags([
                    { type: 'Kanban' },
                    { type: 'ScoutProperty' },
                ])
            );
        } else if (e.data?.type === PropertyBroadcastMessageTypes.ProjectUpdated) {
            store.dispatch(
                aroApiSlice.util.invalidateTags([
                    { type: 'Kanban' },
                    { type: 'ScoutProject' },
                ])
            );
        }
    };
};
